<template>
  <span class="folder-edit-button-component d-inline-block">

    <!-- CHOOSE ACTION -->
    <b-modal ref="chooseActionFolderModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Que souhaitez-vous faire ? </strong>
      </template>
      <div>
        <div class="row">
          <div class="col-sm-4 col-12">
            <b-button variant="outline-dark" pill block @click="$refs.chooseActionFolderModal.hide(); $refs.moveFolderModal.show()">
              Déplacer ce dossier
            </b-button>
          </div>
          <div class="col-sm-4 col-12">
            <b-button variant="outline-primary" pill block @click="$refs.chooseActionFolderModal.hide(); $refs.modifyFolderModal.show()">
              Modifier ce dossier
            </b-button>
          </div>
          <div class="col-sm-4 col-12">
            <b-button variant="outline-danger" pill block @click="$refs.chooseActionFolderModal.hide(); $refs.deleteFolderModal.show()">
              Supprimer ce dossier
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- MODIFY FOLDER -->
    <b-modal ref="modifyFolderModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Modifier votre dossier </strong>
      </template>
      <div>
        <folderModificationComponent
          :token="token"
          :folder="node"
          v-on:folder-modified="folderModified($event)"
        />
      </div>
    </b-modal>

    <b-modal ref="FolderModifiedModal" size="lg" hide-footer title="Dossier modifié">
      <div class="text-center">
        <p><strong>Votre dossier a bien été modifié ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.FolderModifiedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <!-- MOVING FOLDER -->
    <b-modal ref="moveFolderModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Déplacer votre dossier </strong>
      </template>
      <div>
        <folderMovingComponent
          :token="token"
          :folder="node"
          v-on:folder-moved="$refs.moveFolderModal.hide(); $refs.FolderMovedModal.show(); $emit('reset-folders-pages')"
        />
      </div>
    </b-modal>

    <b-modal ref="FolderMovedModal" size="lg" hide-footer title="Dossier déplacé">
      <div class="text-center">
        <p><strong>Votre dossier a bien été déplacé ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.FolderMovedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <!-- DELETE FOLDER -->
    <b-modal ref="deleteFolderModal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <strong> Supprimer votre dossier </strong>
      </template>
      <div>
        <folderDeletionComponent
          :token="token"
          :folder="node"
          v-on:folder-deleted="$refs.deleteFolderModal.hide(); $refs.FolderDeletedModal.show(); $emit('reset-folders-pages')"
        />
      </div>
    </b-modal>

    <b-modal ref="FolderDeletedModal" size="lg" hide-footer title="Dossier supprimé">
      <div class="text-center">
        <p><strong>Votre dossier a bien été supprimé ! </strong></p>
        <b-button class="mt-3" block pull variant="outline-dark" @click="$refs.FolderDeletedModal.hide()">
          Fermer
        </b-button>
      </div>
    </b-modal>

    <b-button v-if="showButton" variant="outline-secondary" size="sm" class="ml-2 folder-edit-btn" @click.stop="showActionModal()">
      <v-icon name="edit" scale="1.1" />
    </b-button>

  </span>
</template>

<script>
import folderModificationComponent from "@/components/folder/folderModificationComponent"
import folderMovingComponent from "@/components/folder/folderMovingComponent"
import folderDeletionComponent from "@/components/folder/folderDeletionComponent"

export default {
  name: 'folderEditButtonComponent',
  props: {
    token: String,
    node: Object,
    showButton: { type: Boolean, default: true }
  },
  components: {
    folderModificationComponent,
    folderMovingComponent,
    folderDeletionComponent
  },
  methods: {
    showActionModal () {
      this.$refs.chooseActionFolderModal.show()
    },
    folderModified (value) {
      this.$refs.modifyFolderModal.hide()
      this.$refs.FolderModifiedModal.show()
      this.node.name = value.name
      this.node.notes = value.notes
      this.node.cron_expression = value.cron_expression
      this.node.requetes = value.requetes
      this.node.requetes_details = value.requetes_details
      this.$emit('folder-modified', value)
    },
  }
}
</script>

<style scoped>
.folder-edit-btn {
  vertical-align: middle;
}
</style>
